import { createFileRoute } from "@tanstack/react-router";
import { FeaturesListPage } from "../../../components/system/FeaturesListPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/features/")({
  beforeLoad: requireSuperAdmin(),
  component: FeaturesRoute,
});

function FeaturesRoute() {
  return <FeaturesListPage />;
}
